module.exports = __webpack_public_path__ + "static/img/quanliucheng_011.a77d81a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quanliucheng_011.png
// module id = Msle
// module chunks = 1